// Third-party systems an order can be imported from. Drives the integration tags on the order
// details card, so adding a source here means adding its tag component to the same map.
export enum OrderSource {
  SHOPIFY = 'shopify',
  ZAPIER = 'zapier',
}
